import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import UserCardAvatar from "../UserCardAvatar";

import "./index.scss";

const CommentPreview = ({
    label,
    meta,
    userId,
    authorName,
    commentText,
    avatarUrl,
    avatarAlt,
    timestamp,
    timestampTitle,
    timestampDateTime,
    cta,
    ariaLabel,
    onClick,
    className,
    ...rest
}) => (
    <button
        type="button"
        className={classNames("comment-preview", className)}
        onClick={onClick}
        aria-label={ariaLabel || label}
        {...rest}
    >
        <div className="comment-preview__eyebrow">
            <span className="comment-preview__label">{label}</span>
            {timestamp && (
                <time
                    className="comment-preview__timestamp"
                    dateTime={timestampDateTime || undefined}
                    title={timestampTitle}
                >
                    {timestamp}
                </time>
            )}
        </div>
        <div className="comment-preview__body">
            <div className="comment-preview__avatar-wrapper">
                <UserCardAvatar
                    userId={userId || undefined}
                    username={authorName}
                    avatarUrl={avatarUrl || undefined}
                    alt={avatarAlt || authorName}
                    className={classNames("comment-preview__avatar", "user-card__avatar--xs")}
                    avatarClassName="comment-preview__avatar-media"
                    enableProfilePreview={Boolean(userId)}
                />
            </div>
            <div className="comment-preview__content">
                <span className="comment-preview__author">{authorName}</span>
                <p className="comment-preview__text">{commentText}</p>
            </div>
        </div>
        {cta && (
            <span className="comment-preview__cta">
                {cta}
                {meta && <span className="comment-preview__cta-meta">{meta}</span>}
            </span>
        )}
    </button>
);

CommentPreview.propTypes = {
    label: PropTypes.string.isRequired,
    meta: PropTypes.string,
    userId: PropTypes.string,
    authorName: PropTypes.string.isRequired,
    commentText: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string,
    avatarAlt: PropTypes.string,
    timestamp: PropTypes.string,
    timestampTitle: PropTypes.string,
    timestampDateTime: PropTypes.string,
    cta: PropTypes.string,
    ariaLabel: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

CommentPreview.defaultProps = {
    meta: "",
    userId: null,
    avatarUrl: null,
    avatarAlt: "",
    timestamp: "",
    timestampTitle: "",
    timestampDateTime: "",
    cta: "",
    ariaLabel: "",
    onClick: () => {},
    className: "",
};

export default CommentPreview;
